import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CountdownTimer } from './CountdownTimer';
import { CHECKOUT_URL, price } from '../data/content';
const notes = ['Pago único · sin suscripción', 'Acceso inmediato a todo el material', 'Garantía de satisfacción de 7 días'];
export function FinalCta() {
  return <section className="bg-grass px-5 py-20 text-white sm:py-24 lg:px-8" data-id="element-106" data-mp="15fgj2o0dj92i">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-107" data-mp="1jbk7u1shap7l">
        <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-white/70" data-id="element-108" data-mp="1eebqg3f5mp7e">
          Cuenta regresiva final
        </p>
        <h2 className="display mt-4 text-4xl sm:text-6xl" data-id="element-109" data-mp="1t1n1833ii56g">
          Paquete completo, precio de lanzamiento
        </h2>

        <div className="mt-8 flex justify-center" data-id="element-110" data-mp="1o5y6qe6cneh0">
          <CountdownTimer tone="dark" data-id="element-111" data-mp="222uxygqdqxyf" />
        </div>

        <p className="mt-10 text-[11px] font-extrabold uppercase tracking-[0.2em] text-white/70" data-id="element-112" data-mp="221a12kglf2xe">
          6 tomos + 5 bonos
        </p>
        <div className="mt-3 flex items-end justify-center gap-4" data-id="element-113" data-mp="n64elx7608q5">
          <span className="display text-6xl sm:text-7xl" data-id="element-114" data-mp="n7yugx3kxand">{price.now}</span>
          <span className="pb-2 text-lg text-white/60 line-through" data-id="element-115" data-mp="s4xolfn8thlk">{price.was}</span>
        </div>
        <p className="mt-3 text-sm font-semibold uppercase tracking-wide text-white/80" data-id="element-116" data-mp="x2h4sl3i44g5">
          Ahorrás {price.savings} hoy
        </p>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="mt-9 inline-flex items-center justify-center rounded-md bg-ink px-8 py-5 text-lg font-extrabold uppercase tracking-tight text-white shadow-[0_8px_0_0_rgba(0,0,0,0.35)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-ink-soft active:translate-y-1 active:shadow-[0_3px_0_0_rgba(0,0,0,0.35)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ink sm:text-2xl" data-id="element-117" data-mp="164qb0yrqlbnq">
          Sí, lo quiero ahora
        </a>

        <ul className="mt-8 flex flex-col items-center gap-2 text-sm text-white/85 sm:flex-row sm:justify-center sm:gap-6" data-id="element-118" data-mp="3qvguc9sd0zh9">
          {notes.map(note => <li key={note} className="flex items-center gap-2" data-id="element-119" data-mp="3hcunl3hpj42">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-120" data-mp="3jpj8h3r6rq3" />
              {note}
            </li>)}
        </ul>
      </Reveal>
    </section>;
}